var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlertOctagon = function SvgAlertOctagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert-octagon_svg__a)",
    fillRule: "evenodd",
    d: "M13.774 3.417h10.45c.89 0 1.608.319 2.228.938l7.442 7.442c.62.62.939 1.337.939 2.228v10.45c0 .89-.32 1.608-.94 2.228l-7.44 7.442c-.62.62-1.338.938-2.229.938h-10.45c-.89 0-1.608-.319-2.228-.938l-7.441-7.442c-.62-.62-.939-1.337-.939-2.228v-10.45c0-.89.319-1.608.939-2.228l7.441-7.442c.62-.62 1.338-.938 2.228-.938m10.43 3.166h-10.41l-7.461 7.461v10.412l.01.008 7.443 7.441.007.012h10.41l.01-.012 7.442-7.441.011-.01v-10.41l-.011-.008zm-5.205 4.75c.812 0 1.482.611 1.573 1.399l.01.185v6.333a1.583 1.583 0 0 1-3.155.185l-.011-.185v-6.333c0-.875.709-1.584 1.583-1.584m.2 15.823A1.584 1.584 0 0 0 19.016 24l-.2.01A1.584 1.584 0 0 0 19 27.167z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert-octagon_svg__a",
    x1: 18.999,
    x2: 18.999,
    y1: 35.083,
    y2: 3.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F87171"
  })))));
};
export default SvgAlertOctagon;